import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { QueryKey, useQuery, UseQueryOptions } from 'react-query';
import { Media } from 'types/media';
import mediaQueryKeys from './mediaQueryKeys';

interface QueryParams {
  id?: string | null;
  options?: Omit<
    UseQueryOptions<Media, Error, Media, QueryKey>,
    'queryKey' | 'queryFn'
  >;
}

export const useMediaQuery = ({ id, options }: QueryParams) => {
  const authState = useAuthSelector();
  const queryKey = mediaQueryKeys.byId(id);

  // force "enabled" to be false if ID is invalid!
  let enabled =
    !id || id?.indexOf('http') === 0 || id?.indexOf('data') === 0
      ? false
      : options?.enabled ?? true;

  const query = useQuery<Media, Error>(
    queryKey,
    () =>
      sdk.media.query.mediaById({ id }, { authToken: authState.auth_token }), // fetchUser(id, authState.auth_token),
    {
      ...options,
      enabled,
    },
  );

  return {
    ...query,
    queryKey,
  };
};

export default useMediaQuery;
